import {createApp} from "vue";
import App from "./App.vue";

//引入ajax
import {ajax} from "@/utils/ajax.js";


//rem适配
import "amfe-flexible";

//全局样式表
import "@/assets/global.css";

//rem适配
import 'amfe-flexible'


let app = createApp(App);


app.config.globalProperties.$ajax = ajax;

// app.use(Toast);
// app.use(DatePicker);
// app.use(vant.Lazyload);

app.mount("#app");
